import ImportHelper from './import.helper'

const GeneralView = () => { return ImportHelper.importAll(require.context("../assets/images/GeneralView/", true, /\.webp/)); }
const Torre1 = () => { return ImportHelper.importAll(require.context("../assets/images/Torre001/", true, /\.webp/)); }
const Torre2 = () => { return ImportHelper.importAll(require.context("../assets/images/Torre002/", true, /\.webp/)); }
const Torre3 = () => { return ImportHelper.importAll(require.context("../assets/images/Torre003/", true, /\.webp/)); }
const Torre4 = () => { return ImportHelper.importAll(require.context("../assets/images/Torre004/", true, /\.webp/)); }


export const ContextLoader = {
    "General View": GeneralView,
    "Torre 4": Torre4,
    "Torre 3": Torre2,
    "Torre 2": Torre3,
    "Torre 1": Torre1,
    "Portería 1": () => { return { length: 0 } },
    "Portería 2": () => { return { length: 0 } },
    "Piscina Adultos y Niños": () => { return { length: 0 } },
    "Juegos Infantiles": () => { return { length: 0 } },
    "Cancha Fútbol 5": () => { return { length: 0 } },
    "Playground": () => { return { length: 0 } },
    "Sala de Cine": () => { return { length: 0 } },
    "Salón Social": () => { return { length: 0 } },
    "Co-working": () => { return { length: 0 } },
    "Gimnasio": () => { return { length: 0 } },
    "Salón Hobbies": () => { return { length: 0 } },
    "Taller Artes": () => { return { length: 0 } }
}